import styled from "styled-components";

export const Container = styled.div`
  .slide-Alianz {
    width: 100%;
    height: 670px;
    padding: 0 25px;
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: center;

    .headline-text {
      font-size: 18px;
      color: #004a93;
      text-transform: uppercase;
      padding-left: 15px;
      border-left: 16px solid #004a93;
      min-height: 40px;
      margin-bottom: 22px;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      line-height: 22px;
      text-align: left;

      &.no-padding {
        padding-left: 0;
      }

      &.font-30 {
        font-size: 30px;
      }
    }
    .headline-text-bold {
      font-size: 18px;
      font-weight: bold;
      position: absolute;
      color: #004a93;
      padding-left: 50px;
    }

    .blue-rect {
      width: 15px;
      height: 35px;
      background-color: #004a93;
      position: absolute;
      top: -11px;
      margin: 0;
      display: inline-block;
      left: 0;
    }

    .cell_0margin {
      p {
        margin: 0;
      }
    }

    .space1 {
      margin-top: 20px;
    }

    .space2 {
      margin-top: 40px;
    }

    .space3 {
      margin-top: 60px;
    }

    .space4 {
      margin-top: 80px;
    }

    .space5 {
      margin-top: 100px;
    }

    .bottom-text {
      color: #004a93;
      margin: 0;
      font-size: 14px;
      text-align: left;
      padding-bottom: 10px;
      line-height: 20px;

      &:first-letter {
        color: red;
      }
    }

    .space-left-blue-table1 {
      margin-top: -30px;
      padding-left: 300px;
      margin-bottom: 0;
    }

    .space-blue-table2 {
      margin-top: -10px;
      margin-bottom: 0;
    }

    .space-big-table3 {
      margin-top: 0;
      margin-bottom: 0;
    }

    .space-big-table4 {
      margin-top: 20px;
      margin-bottom: 0;
    }

    .space-big-table5 {
      margin-top: 40px;
      margin-bottom: 0;
    }

    .guarantee-headline {
      font-size: 1.5em;
      margin: 0;
      font-weight: bold;
      color: #86003a;
      padding-top: 5px;
      text-transform: uppercase;
      padding-left: 40px;
      margin-left: 50%;
    }

    .slide3-margin {
      margin-top: 90px;
      margin-bottom: 30px;
    }

    .blue-ok {
      &:before {
        content: '';
        border-color: transparent;
        border-width: 0;
        border-right: 3px solid #004a93;
        border-bottom: 3px solid #004a93;
        width: 5px;
        height: 10px;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        margin: 0 auto;
        display: block;
      }
    }

    .orange-ok {
      &:before {
        content: '';
        border-color: transparent;
        border-width: 0;
        border-right: 3px solid #fc7400;
        border-bottom: 3px solid #fc7400;
        width: 5px;
        height: 15px;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        margin: 0 auto;
        display: block;
      }
    }

    .headline-list {
      font-size: 18px;
      color: #005b73;
      margin-top: 30px;
      margin-bottom: 20px;
      font-weight: bold;
      margin-left: 50%;
    }

    .headline-img-cross {
      width: 45px;
    }

    .list-item {
      color: #005b73;
      margin: 4px;
      line-height: 20px;
      font-size: 13px;
      padding-left: 10px;
      position: relative;
      margin-left: 52%;

      &:before {
        position: absolute;
        content: '\\2022';
        font-size: 22px;
        left: -10px;
        line-height: 20px;
        color: #005b73;
      }
    }

    .right-column {
      width: 50%;
      text-align: left;
      margin-left: 50%;
    }

    .box {
      display: inline-block;
    }

    .col-12 {
      width: 100%;
    }

    .pl_shape4 {
      position: relative;

      &:after {
        position: absolute;
        bottom: 3px;
        content: '';
        width: 2px;
        height: 5px;
        background-color: #003263;
      }
    }

    .pos-ab {
      position: absolute;
    }

    .slider {
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .paragraph {
      width: 100%;
      margin-top: 100px;
    }

    .small-margin-bottom {
      margin-bottom: 8px;
    }

    .small-margin-top {
      margin-top: 8px;
    }

    .space-right {
      margin-right: 1.2em;
    }

    .space-left {
      margin-left: 1.2em;
    }

    .center-wrap {
      text-align: center;
    }

    .space-between {
      margin-left: 0.5em;
      margin-right: 0.5em;
    }

    .btn-pos-abs {
      position: absolute;
      right: 25px;
      bottom: 0;
      margin-bottom: 20px;
    }

    .slide3 {
      width: 140px;
    }

    .slide11 {
      width: 230px;
    }

    &.blue-table {
      height: auto;
    }

    &.blue-table-2 {
      height: auto;
    }

    &.orange-table {
      height: auto;
    }

    .col-head {
      background-color: #004a93;
      color: #FFFFFF;
      font-weight: bold;
    }

    .row-space {
      height: 15px;
      background-color: #fff !important;
      padding: 0;
    }

    td {
      vertical-align: middle;
    }
  }

  .cell_paragraph {
    p {
      margin: 0;

      &:last-child {
        font-weight: bold;
      }
    }
  }

  .cell_paragraph_normal {
    p {
      margin: 0;
    }
  }

  .smaller {
    p {
      margin: 0;
      font-size: 12px !important;
    }
  }

  .more-space-from-top {
    margin-top: 0px;

    tr:nth-child(2) {
      td {
        font-weight: 600;
      }
    }
  }

  .blue-table {
    overflow: auto;
    text-align: center;
    vertical-align: middle;
    margin: 80px 0;
    width: 100%;

    tbody {
      tr:nth-child(1),
      tr:nth-child(2) {
        background-color: #004a93;

        td {
          font-size: 17px;
          color: #FFFFFF;
        }
      }

      tr:nth-child(2) {
        td {
          font-weight: 600;
        }
      }

      tr {
        background-color: #ccdbeb;
      }

      .bold-row {
        font-weight: 600;
        color: #FFFFFF;
        background-color: #004a93;
      }
    }

    td {
      font-size: 14px;
      color: #004a93;
      padding: 0.9rem 0.4rem !important;
      border: 1px solid #FFFFFF;
      vertical-align: middle;
      line-height: 20px;
    }
  }

  .blue-line-table {
    overflow: auto;
    text-align: center;
    vertical-align: middle;
    position: absolute;
    top: 73px;
    border-bottom: 1px solid #04425a;
    border-top: 1px solid #04425a;
    border-spacing: 0;
    width: 100%;

    tbody {
      tr:nth-child(1) {
        //background-color: #004a93;

        td {
          margin: 0;
          border-top: none !important;
          font-size: 18px;
          color: #04425a;
        }
      }

      tr:nth-child(1) {
        td {
          font-weight: 600;
        }
      }
    }

    td {
      font-size: 18px;
      color: #04425a;
      padding: 1.5rem .7rem !important;
      border-top: 1px solid #04425a;
    }
  }

  .blue-table-3 {
    text-align: center;
    vertical-align: middle;
    width: 100%;

    tbody {
      tr {
        td:nth-child(1) {
          background-color: #004a93;
          color: #FFFFFF;

          p {
            margin: 0;
          }
        }

        td:nth-child(2) {
          background-color: #ccdbeb;
          color: #004a93;

          p {
            margin: 0;
          }
        }
      }

      tr:nth-child(2) {
        td:nth-child(2) {
          color: #004a93;

          p {
            margin: 0;
          }
        }
      }

      tr {
        background-color: #ccdbeb;
      }

      .bold-row {
        font-weight: 600;
        color: #FFFFFF;
        background-color: #004a93;
      }
    }

    td {
      font-size: 14px;
      color: #004a93;
      padding: 6rem 5.8rem !important;
      border: 1px solid #FFFFFF;
      vertical-align: middle;

      @media screen and (max-width: 768px) {
        padding: 4rem 0.8rem !important;
      }
    }
  }

  .blue-table-2 {
    text-align: center;
    vertical-align: middle;
    margin: 80px auto;

    tbody {
      tr:first-child {
        td {
          font-weight: bold;
        }
      }

      tr:nth-child(1),
      tr:nth-child(2) {
        background-color: #004a93;

        td {
          font-size: 14px;
          color: #FFFFFF;
        }
      }

      tr:nth-child(1),
      tr:nth-child(3),
      tr:nth-child(4),
      tr:nth-child(5) {
        td:nth-child(1) {
          padding: 0.8rem 2.1rem;
        }
      }

      tr:nth-child(2) {
        td {
          font-weight: 300;
        }
      }

      tr {
        td:nth-child(1) {
          background-color: #004a93;
          color: #FFFFFF;
        }

        background-color: #ccdbeb;
      }
    }

    td {
      font-size: 13px;
      color: #004a93;
      padding: 1rem 0.4rem;
      border: 1px solid #FFFFFF;
    }
  }

  .blue-table-1 {
    text-align: center;
    vertical-align: middle;

    tbody {
      tr:first-child {
        td {
          font-weight: 600;
        }
      }

      tr:nth-child(1),
      tr:nth-child(2) {
        background-color: #004a93;

        td {
          font-size: 11px;
          color: #FFFFFF;
        }
      }

      tr:nth-child(1),
      tr:nth-child(3),
      tr:nth-child(4),
      tr:nth-child(5) {
        td:nth-child(1) {
          padding: 0.1rem 0.4rem;
        }
      }

      tr:nth-child(2) {
        td {
          font-weight: 600;
        }
      }

      tr {
        td:nth-child(1) {
          width: 34%;
        }

        background-color: #ccdbeb;
      }
    }

    td {
      font-size: 10px;
      color: #004a93;
      padding: 0.2rem 0.1rem;
      border: 1px solid #FFFFFF;
    }
  }

  .orange-table {
    padding-top: 20px;
    text-align: center;
    vertical-align: middle;
    margin: 80px auto;

    tbody {
      tr:first-child {
        td {
          font-weight: 600;
          background-color: #fc7400 !important;
          color: #FFFFFF;
          font-size: 15px;
        }
      }

      tr:nth-child(2) {
        td:first-child {
          width: 50%;
        }
      }

      tr {
        background-color: #ccdbeb;
      }
    }

    td {
      font-size: 13px;
      color: #004a93;
      padding: 0.9rem 1.9rem;
      border: 1px solid #ffffff;
    }
  }

  .slide-insurance {
    width: 100%;
    height: 650px;
    padding: 0 25px;
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('data:image/jpeg;base64,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');

    @media screen and (max-width: 768px) {
      height: auto;
    }

    .flex-flow-column {
      flex-flow: column !important;

      .col-0,
      .col-1 {
        width: 100% !important;
        justify-content: center;
      }
    }

    .row-space {
      height: 15px;
      background-color: transparent !important;
      padding: 0;
    }

    .button-wrap {
      position: absolute;
      bottom: 36px;
      z-index: 2;
      right: 25px;

      .btn-pos-abs {
        margin-bottom: 0px;
      }
    }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      &.table-wrap {
        height: 100%;
      }

      .col-0,
      .col-1 {
        width: 50%;
        display: flex;
        justify-content: center;

        img {
          max-width: 100%;
        }

        @media screen and (max-width: 768px) {
          width: 100%;
          padding: 20px 0;
        }
      }

      .col-1 {
        @media screen and (max-width: 768px) {
          padding-bottom: 70px;
        }
      }

      @media screen and (max-width: 768px) {
        flex-flow: column;
      }

      .headline {
        font-size: 12px !important;

        &.show1 {
          padding:15px 0;
          max-width: 700px;
        }
      }

      .lightBlue-table {
        text-align: center;
        width: 100%;
        z-index: 2;
        box-shadow: 6px 6px 0px 0px rgba(60, 130, 142, 0.3);
        border-spacing: 0;
        border-collapse: separate;
        margin: 0 0 90px 0;

        tbody {
          tr:nth-child(1) {
            td {
              font-weight: 100;
              text-align: center !important;
            }
          }

          tr:nth-child(1),
          tr:nth-child(2) {
            background-color: #70B9CD;

            td {
              color: #FFFFFF;
            }
          }

          tr:nth-child(2) {
            td:first-child {
              font-weight: 300;
            }

            td {
              font-weight: 600;
            }
          }

          tr {
            background-color: #C2E0E9;

            td {
              color: #8C8C8C;
              border-top: 1px solid #ffffff;
              border-left: 1px solid #ffffff;
              vertical-align: middle;
            }

            td:first-child {
              background-color: #70B9CD;
              border-left: none;
              padding-left: 70px;
              text-align: left;
              color: #ffffff;
            }
          }

          .bold-row {
            font-weight: 600;
            color: #FFFFFF;
            background-color: #70B9CD;
          }
        }

        td {
          font-size: 14px;
          color: #8C8C8C;
          padding: 0.5rem 0.7rem !important;
        }

        &.higher {
          tbody {
            tr:nth-child(2) {
              td {
                font-weight: 100;
                text-align: center !important;
                padding: 0.4rem 0.4rem !important;
              }
            }

            td {
              font-size: 14px;
              color: #8C8C8C;
              padding: 0.4rem 0.7rem !important;
            }
          }
        }

        &.morehigher {
          tbody {
            tr:nth-child(2) {
              td {
                font-weight: 100;
                text-align: center !important;
                padding: 0.6rem 0.4rem !important;
              }
            }

            td {
              font-size: 14px;
              color: #8C8C8C;
              padding: 0.7rem 0.7rem !important;
            }
          }
        }

        &.toTop {
          margin-top: 35px !important;
        }

        &.lastCenter {
          margin-top: 35px !important;

          tr:last-child {
            td {
              background-color: #C2E0E9;
              text-align: center;
              color: #8C8C8C;
            }
          }
        }
      }

      .specialPadding {
        tbody {
          tr {
            td:nth-child(2) {
              padding: 0.4rem 2.8rem !important;
            }

            td:nth-child(3) {
              padding: 0.4rem 0.5rem !important;
            }

            td:nth-child(4) {
              padding: 0.4rem 0.6rem !important;
            }

            td:nth-child(5) {
              padding: 0.4rem 0.9rem !important;
            }
          }
        }
      }
    }

    .button-wrap {
      position: absolute;
      bottom: 36px;
      z-index: 2;
      right: 25px;
    }
  }

///////////////////////////////////////////////////////////////////////////////////////
.guaranteed_car {
    padding: 0 20px;
    width: 100%;
    height: 670px;
    position: relative;

    .flex-flow-column {
      flex-flow: column !important;

      .col-0,
      .col-1 {
        width: 100% !important;
        justify-content: left !important;
      }
    }

    .row-space {
      height: 4px;
      background-color: #fff !important;
      padding: 0;
      border: 0 !important;
    }

    @media screen and (max-width: 768px) {
      height: auto;
    }

    .guarantee-headline-box {
      position: relative;

      @media screen and (max-width: 768px) {
        margin-left: 50px;
      }
    }

    .wrapper {
      display: flex;
      align-items: center;

      &.table-wrap {
        height: 100%;
      }

      .col-0,
      .col-1 {
        width: 50%;
        display: flex;
        justify-content: center;

        img {
          max-width: 100%;
        }

        @media screen and (max-width: 768px) {
          width: 100%;
          padding: 20px 0;
        }
      }

      .col-1 {
        @media screen and (max-width: 768px) {
          padding-bottom: 70px;
        }
      }

      @media screen and (max-width: 768px) {
        flex-flow: column;
      }
    }

    .button-wrap {
      position: absolute;
      bottom: 36px;
      z-index: 2;
      right: 25px;

      .btn-pos-abs {
        margin-bottom: 0px;
      }
    }

    &.more-space-from-top {
      padding-top: 0px;
    }

    .guarantee-text-bold {
      font-weight: bold;
      font-size: 13px;
      color: #147ca3;
      text-transform: uppercase;
      padding-bottom: 10px;
    }

    .guarantee-text {
      font-size: 13px;
      color: #147ca3;
      padding-bottom: 10px;
    }

    .space-big-table5 {
      margin-bottom: -10px;
    }

    .guarantee-headline {
      font-size: 1.5em;
      margin: 0;
      margin-left: 0px;
      font-weight: bold;
      color: #86003a;
      padding-top: 5px;
      text-transform: uppercase;
    }

    .headline-list {
      font-size: 18px;
      color: #005b73;
      margin-top: 30px;
      margin-bottom: 20px;
      font-weight: bold;
    }

    .list-item {
      color: #005b73;
      margin: 4px;
      margin-left: 4px;
      line-height: 20px;
      font-size: 13px;
      padding-left: 10px;
      position: relative;
    }

    .list-item::before {
      position: absolute;
      content: '\\2022';
      font-size: 22px;
      left: -10px;
      line-height: 20px;
      color: #005b73;
    }

    .headline-img-cross {
      width: 45px;
    }

    .slide3 {
      width: 140px;
    }

    .slide3-margin {
      margin-bottom: 30px;
    }

    .table-container-guarantee {
      height: 500px;
      width: 100%;
      overflow: auto;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-pack: start;
      justify-content: flex-start;
      -ms-flex-align: start;
      align-items: flex-start;

      @media screen and (max-width: 768px) {
        height: auto;
      }
    }

    .table-container-guarantee .table-wrap {
      width: 100%;
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-direction: column;
      flex-direction: column;
      padding: 2px;
      padding-top: 2px;
      padding-top: 0;
    }

    .table-container-guarantee .table-wrap table {
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;

      @media screen and (max-width: 768px) {
        margin-bottom: 100px;
      }
    }

    .table-container-guarantee .table-wrap table td {
      font-size: 13px;
      color: #147ca3;
    }

    .table-container-guarantee .table-wrap table td {
      border: 2px solid #b5dce1;
      max-width: 430px;
      text-align: center;
    }

    .first-column-header,
    .big-table {
      tr:first-of-type {
        td {
          border: 0;
          color: #fff;
        }
      }

      .first-td {
        background-clip: padding-box;
        background-color: #b5dce1;
        color: white;
        border: 5px solid #b5dce1;
        border-top-left-radius: 15px;
        text-align: center;
        border-top-right-radius: 15px;
      }

      .inside_table {
        margin: 0;
      }

      .second-td {
        background-clip: padding-box;
        background-color: #6898a9;
        color: white;
        border: 5px solid #6898a9;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        text-align: center;
      }

      .third-td {
        background-clip: padding-box;
        background-color: #e8d2a9;
        color: white;
        border: 5px solid #e8d2a9;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        text-align: center;
      }

      .fourth-td {
        background-clip: padding-box;
        background-color: #a6a8aa;
        color: white;
        border: 5px solid #a6a8aa;
        border-top-left-radius: 15px;
        text-align: center;
        border-top-right-radius: 15px;
      }

      td.no-border {
        border: 0 !important;
        color: #fff !important;
      }

      td:nth-child(1) {
        width: 350px;
        text-align: left !important;
      }

      td {
        padding: 1.5rem 0.5rem;
      }
    }

    .first-column-header {
      margin-top: 115px;
    }

    .big-table {
      margin-top: 25px;

      td {
        padding: .8rem;
      }
    }
  }

  .elearning-player-content .spinner {
    transition: all .2s ease;
    position: absolute;
    display: -ms-flexbox;
    display: flex;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 100;
    pointer-events: none;
    opacity: 0;
    top: 0;
    left: 0;
  }

  .slide-life-up {
    .headline:not(.bottom-text) {
      font-size: 26px;
      color: #00435b;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
      padding-top: 90px;

      @media screen and (max-width: 768px) {
        padding: 125px 10px 0 10px;
        line-height: 30px;
      }
    }

    table {
      margin: 0 auto;
      border-collapse: separate;
      border-spacing: 10px;

      tr {
        .table-head {
          background: #00435b;
          color: #fff;
          font-weight: bold;
        }

        .table-subhead {
          background: #4c7b8c;
          color: #fff;
          font-weight: bold;
        }

        td {
          height: 45px;
          vertical-align: middle;
          font-size: 16px;
          color: #00435b;
          background: #a3cdd4;
          padding: 0 10px 0 50px;
          line-height: 21px;

          &:not(:first-of-type) {
            text-align: center;
            padding: 0 20px;

            @media screen and (max-width: 768px) {
              padding: 10px;
              min-width: 60px;
            }
          }

          @media screen and (max-width: 768px) {
            padding: 10px;
          }
        }

        .answer-no {
          color: #9e0039;
        }
      }
    }

    .table-footer {
      background: #00435b;
      display: flex;
      color: #fff;
      font-size: 14px;
      height: 60px;
      align-items: center;
      justify-content: center;
      margin-top: 15px;
      margin-bottom: 75px;

      @media screen and (max-width: 768px) {
        flex-flow: column;
        height: 100px;
        text-align: center;
        padding: 0 10px;
        line-height: 19px;

        div {
          padding: 2px 0;
        }
      }
      div + div {
        margin-left: 30px;
      }
    }

    .button-wrap {
      position: absolute;
      bottom: -55px;
      z-index: 2;
      right: 25px;

      .btn-pos-abs {
        margin-bottom: 0px;
      }
    }

    .row-space {
      height: 15px;
      background-color: #fff !important;
      padding: 0;
    }
  }

  .single-image, .single-image-arrow {
    .button-wrap {
      position: absolute;
      bottom: 36px;
      z-index: 2;
      right: 25px;

      .btn-pos-abs {
        margin-bottom: 0;
      }
    }

    img {
      max-width: 100%;
    }
  }
`;
